<div mat-dialog-title>
  <div>Update Custom Offer</div>
  <div (click)="onNoClick()" class="close-icon-container">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (updateCustomOfferForm) {
    <form [formGroup]="updateCustomOfferForm">
      <div class="form-container">
        <div class="fields">
          <mat-form-field class="w-100-1">
            <mat-label>Base Enrollment Group</mat-label>
            @if (site?.acceptedCustomTerms !== null && site?.acceptedCustomTerms) {
              <mat-hint>Can't change group if site has custom terms selected.</mat-hint>
            }
            <mat-select
              (selectionChange)="changeBaseGroup($event.value)"
              class="select-control"
              formControlName="enrollmentGroupId">
              @for (group of enrollmentGroups; track group) {
                <mat-option [value]="group.id">
                  {{ group.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="row">
            <mat-form-field class="w-50-2">
              <mat-label>Price per Ton</mat-label>
              <input currencyMask formControlName="pricePerTon" id="pricePerTon" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Minimum Price per Ton</mat-label>
              <input currencyMask formControlName="pricePerTonMin" id="pricePerTonMin" matInput type="text" />
            </mat-form-field>
          </div>
          <mat-form-field class="w-50-2">
            <mat-label>
              Market Price Percentage
              <fa-icon
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
                [icon]="['far', 'circle-info']"
                class="blue"
                matTooltip="The percentage of market price to pay the landowner during variable years, in decimal form. A value of 55% should be entered as 0.55"
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
            </mat-label>
            <input formControlName="marketPricePercentage" id="marketPricePercentage" matInput type="text" />
          </mat-form-field>
          <div class="row">
            <mat-form-field class="w-50-2">
              <mat-label>
                Internal Buffer Value
                <fa-icon
                  #tooltip="matTooltip"
                  (click)="tooltip.toggle()"
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="The internal buffer value, in decimal form. A buffer value of 15% should be entered as 0.15"
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </mat-label>
              <input formControlName="internalBufferValue" id="internalBufferValue" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>
                Initial Fixed Years
                <fa-icon
                  #tooltip="matTooltip"
                  (click)="tooltip.toggle()"
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="The number of fixed price years. After X years, the pricing model will shift to a variable rate, and any changes to the PPT will cause a re-calculation of any payment period greater than this value. This value should equal the number of total payment periods in the case of fully fixed pricing."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </mat-label>
              <input
                formControlName="initialFixedYears"
                id="initialFixedYears"
                matInput
                type="number"
                pattern="[0-9]*"
                min="0"
                max="20" />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="w-50-2">
              <mat-label>Minimum Payment per Acre</mat-label>
              <input
                currencyMask
                formControlName="minimumPaymentPerAcre"
                id="minimumPaymentPerAcre"
                matInput
                type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Minimum ERT per Acre</mat-label>
              <input formControlName="minimumErtPerAcre" id="minimumErtPerAcre" matInput type="text" />
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="w-33-3">
              <mat-label>Bonus Amount</mat-label>
              <input currencyMask formControlName="bonusAmount" id="bonusAmount" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-33-3">
              <mat-label>Bonus Length (# of Periods)</mat-label>
              <input
                formControlName="bonusLength"
                id="bonusLength"
                matInput
                type="number"
                pattern="[0-9]*"
                min="0" />
            </mat-form-field>
            <div class="w-33-3">
              PPT?
              <fa-icon
                #tooltip="matTooltip"
                [icon]="['far', 'circle-info']"
                class="blue"
                matTooltip="The PPT bonus will be calculated based on the yearly valuation."
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
              <mat-slide-toggle
                color="primary"
                formControlName="bonusIsPpt"
                data-cy="show-modify-toggle"></mat-slide-toggle>
            </div>
          </div>
          <mat-form-field class="w-100-1">
            <mat-label>Terms URL</mat-label>
            <input formControlName="termsUrl" id="termsUrl" matInput type="text" />
          </mat-form-field>
          <mat-form-field class="w-100-1">
            <mat-label>FAQs</mat-label>
            <textarea formControlName="faqs" placeholder="FAQs JSON" id="faqs" matInput rows="4"></textarea>
          </mat-form-field>
          <mat-form-field class="w-100-1" data-cy="comments" subscriptSizing="dynamic">
            <textarea matInput placeholder="Comments" id="comments" formControlName="comments" required
                      rows="4"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  }
</div>
<div mat-dialog-actions>
  @if (customOffer) {
    <span
      class="delete-button-parent"
      [matTooltip]="site?.acceptedCustomTerms ? 'Cannot delete offer while site has it selected' : ''">
    <button
      (click)="deleteOffer()"
      [disabled]="site.activationDate !== null || site?.acceptedCustomTerms"
      color="warn"
      data-cy="button-delete"
      mat-stroked-button>
      Delete Offer
    </button>
    </span>
  }
  <button
    (click)="onSubmit()"
    [disabled]="updateCustomOfferForm?.invalid || site.activationDate !== null"
    color="primary"
    data-cy="button-submit"
    mat-raised-button>
    Save
  </button>
</div>
